
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mobile/collection/[id]",
      function () {
        return require("private-next-pages/mobile/collection/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mobile/collection/[id]"])
      });
    }
  